import axios from 'axios';
import moment from 'moment';
import '@/filters';
import users from '@/users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: 'customerApplications',
  components: {
    DataGridComp: require('@/customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
    MenuListItem: require('@/employee/enquiries/menuListItem.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      settingFor: 'customer',
      isDetLoading: true,
      customerAllData: null,
      menuVisible: true,
      customerName: '',
      lang: '',

      property: null,
      accountApplications: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "applicationId",
        isLoading: true,
      },
      propertiesApplications: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "applicationId",
        isLoading: true,
      },    

      propId: null,
      custkey: null,

      pagesLoaded: ['PropertiesApplications', 'AccountApplications'],
    }
  },
  mounted() {
    this.goToDefaultTab(this.selectedTab);
  },
  computed: {   
    isLoading: function () {
      return this.accountApplications.isLoading && this.propertiesApplications.isLoading ;
    },
    showEmptyState: function () {
      if ((this.accountApplications.data.length == 0 && this.selectedTab == 'AccountApplications') ||
        (this.propertiesApplications.data.length == 0 && this.selectedTab == 'PropertiesApplications'))
        return true;
      else
        return false;
    },
  },
  watch: {
    selectedTab: function (val) {
      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrlLink(val);
    }
  },
  methods: {
    init() {
      this.propId = this.$route.params.propertyId;
      this.custkey = this.$route.params.custkey;      

      this.selectedTab = 'AccountApplications';
      this.isApplicationsExpanded = true,

      this.fillColumns();
      this.getData();
    },
    fillColumns() {
      this.accountApplications.cols.length = 0;
      this.propertiesApplications.cols.length = 0;

      this.accountApplications.cols.push({ dataField: 'sourceTypeS', caption: this.$t('enquiriesAccount.sourceTypeS') });
      this.accountApplications.cols.push({ dataField: 'applicationId', caption: this.$t('enquiriesAccount.applicationId') });
      this.accountApplications.cols.push({ dataField: 'applicationDate', caption: this.$t('enquiriesAccount.applicationDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.accountApplications.cols.push({ dataField: 'applicationType', caption: this.$t('enquiriesAccount.applicationType') });
      this.accountApplications.cols.push({ dataField: 'status', caption: this.$t('enquiriesAccount.status') });
      this.accountApplications.cols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesAccount.propertyRef') });
      this.accountApplications.cols.push({ dataField: 'address', caption: this.$t('enquiriesAccount.address') });
      this.accountApplications.cols.push({ dataField: 'hasDigitalSignatures', caption: this.$t('enquiriesAccount.hasDigitalSignatures') });
      this.accountApplications.cols.push({ dataField: 'stampUser', caption: this.$t('enquiries.stampUser') });

      this.propertiesApplications.cols.push({ dataField: 'applicationId', caption: this.$t('enquiriesAccount.applicationId') });
      this.propertiesApplications.cols.push({ dataField: 'applicationDate', caption: this.$t('enquiriesAccount.applicationDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.propertiesApplications.cols.push({ dataField: 'applicationType', caption: this.$t('enquiriesAccount.applicationType') });
      this.propertiesApplications.cols.push({ dataField: 'status', caption: this.$t('enquiriesAccount.status') });
      this.propertiesApplications.cols.push({ dataField: 'comment', caption: this.$t('enquiriesAccount.comment') });
      this.propertiesApplications.cols.push({ dataField: 'hasDigitalSignatures', caption: this.$t('enquiriesAccount.hasDigitalSignatures') });
      this.propertiesApplications.cols.push({ dataField: 'stampUser', caption: this.$t('enquiries.stampUser') });
    },
    getData() {
      this.getPropertyApplications(true);
      this.getAccountApplications(true);

      this.getCustomerDisplayInfo();
    },

    getPropertyApplications(loader = false) {
      this.propertiesApplications.isLoading = loader;

      var parameters = {
        propertyId: this.propId,
        loginEmail: this.getLoginName(),
        Options: this.propertiesApplications.pageingOption
      }

      axios.post('/Enquiries/getPropertyApplications', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.propertiesApplications.data = response.data.items;

            this.propertiesApplications.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.propertiesApplications.isLoading = false);
    },
    getAccountApplications(loader = false) {
        this.accountApplications.isLoading = loader;

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.accountApplications.pageingOption
      }

      axios.post('/Enquiries/getAccountApplications', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.accountApplications.data = response.data.items;

            this.accountApplications.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.accountApplications.isLoading = false);
    },

    showApplicationDetails(info) {
      //old app type do not open
      if (info.data.sourceType == 1) {
        this.$oldAlertMsg(this.$t('enquiries.cantOpenOldApp'));
        return;
      }

      let routeData = this.$router.resolve({ name: 'showApplication', params: { id: info.data.applicationId } });
      window.open(routeData.href, '_blank');
    },
  },
}
